import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Divider,
  Box,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import BarChartRoundedIcon from '@material-ui/icons/BarChartRounded';
import AccountBoxRoundedIcon from '@material-ui/icons/AccountBoxRounded';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import InputIcon from '@material-ui/icons/Input';
import NavItem from './NavItem';
import avatar from '../../img/logo-gmi.png';
import { Button } from '@mui/material';

const client = {
  avatar: avatar,
  name: 'GMI AERO'
};

const items = [
  {
    href: '/app/reportconfig',
    icon: BarChartRoundedIcon,
    title: 'New Report'
  }
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    backgroundColor: 'var(--gmi-color)',
    width: 256
  },
  desktopDrawer: {
    backgroundColor: 'var(--gmi-color)',
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    border: 'white 1px solid',
    cursor: 'pointer',
    width: 100,
    height: 100
  },
  name: {
    marginTop: '15px',
    color: 'white'
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose === false) {
      onMobileClose();
    }
  }, [location.pathname, onMobileClose, openMobile]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          src={client.avatar}
        />
        <Typography
          className={classes.name}
          variant="h6"
        >
          {client.name}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
      <Box
        p={2}
        m={2}
      >
        <List>
            <NavItem
              href='/login'
              key='Logout'
              title='Logout'
              icon={InputIcon}
            />
            
        </List>
       
      </Box>
    </Box>
  );

  return (
    <Fragment>
      <Hidden mdUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
        <Button>aa</Button>
      </Hidden>
      
      <Hidden smDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
